import React from 'react'
import { Link } from 'react-router-dom'
import Layout from '../component/Layout/Layout'

function NotFound() {
    return (
        <Layout title="Page NotFound : Chaashni by Maansi & Ketan" description="Chaashni by Maansi & Ketan: Description" > 
        <div className="site-content-wrap pnf-template">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                    <div className="pnf-inner-wrap">
                        <div className="pnf-inner text-center">
                            <h1>404</h1>
                            <h2>PAGE NOT FOUND</h2>
                            <p>The page you are looking for does not exist or has been moved.</p>
                            <Link to="/" className="pnf-btn"> Go back to home page </Link>
                        </div>
                    </div>                           
                    </div>
                </div>
            </div>
        </div>
        </Layout>
    )
}

export default NotFound
